

const LessonLinkList =[
  {order: "01", lesson: "Overview", lessonTitle: "", linkArr:
     [{linkItem: "LP_Overview", linkText: "Lesson Plan Overview"},
      {linkItem: "FG_Overview", linkText: "Facilitator Guide - Overview"},
      {linkItem: "Overview_PFL_List", linkText: "Colorado Fin Law (PFL)- Lesson Mapping"},
      {linkItem: "Full_PFL_List2", linkText: "Full Colorado Fin Law (PFL) Course Review"}]
  },
   {order: "02", lesson: "Lesson 1", lessonTitle: "Starting Your Financial Journey", linkArr:
     [{linkItem: "LP_Lesson_1", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_1", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_1", linkText: "Student Worksheet"}],
  },
  {order: "03", lesson: "Lesson 2", lessonTitle: "Financial Foundations", linkArr:
     [{linkItem: "LP_Lesson_2", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_2", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_2", linkText: "Student Worksheet"}],
  }, 
  {order: "04", lesson: "Lesson 3", lessonTitle: "Choosing a Career", linkArr:
     [{linkItem: "LP_Lesson_3", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_3", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_3", linkText: "Student Worksheet"}],
  }, 
  {order: "05", lesson: "Lesson 4", lessonTitle: "Living Below Your Means", linkArr:
     [{linkItem: "LP_Lesson_4", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_4", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_4", linkText: "Student Worksheet"}],
  }, 
  {order: "06", lesson: "Lesson 5", lessonTitle: "Choosing a Home (Rent vs. Buy)", linkArr:
     [{linkItem: "LP_Lesson_5", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_5", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_5", linkText: "Student Worksheet"}],
  }, 
   {order: "07", lesson: "Lesson 6", lessonTitle: "Choosing a Car", linkArr:
     [{linkItem: "LP_Lesson_6", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_6", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_6", linkText: "Student Worksheet"}],
  },
  {order: "08", lesson: "Lesson 7", lessonTitle: "Understanding Loans", linkArr:
     [{linkItem: "LP_Lesson_7", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_7", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_7", linkText: "Student Worksheet"}],
  },
  {order: "09", lesson: "Lesson 8", lessonTitle: "Credit Cards", linkArr:
     [{linkItem: "LP_Lesson_8", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_8", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_8", linkText: "Student Worksheet"}],
  },
  {order: "10", lesson: "Lesson 9", lessonTitle: "Savings", linkArr:
     [{linkItem: "LP_Lesson_9", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_9", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_9", linkText: "Student Worksheet"}],
  },
  {order: "11", lesson: "Lesson 10", lessonTitle: "Investing", linkArr:
     [{linkItem: "LP_Lesson_10", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_10", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_10", linkText: "Student Worksheet"}],
  },
  {order: "12", lesson: "Lesson 11", lessonTitle: "Insurance", linkArr:
     [{linkItem: "LP_Lesson_11", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_11", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_11", linkText: "Student Worksheet"}],
  },
  {order: "13", lesson: "Lesson 12", lessonTitle: "Review and FAFSA", linkArr:
     [{linkItem: "LP_Lesson_12", linkText: "Lesson Plan"},
      {linkItem: "FG_Lesson_12", linkText: "Facilitator Guide"},
      {linkItem: "WS_Lesson_12", linkText: "Student Worksheet"}],
  },
   ]

export default LessonLinkList;